export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			admin: {
				header: {
					title: 'Admin',
				},
				systemActions: {
					title: 'System actions',
					badge: 'Quick tools',
					description:
						'Execute maintenance and cache operations safely. Results appear in the log above.',
					buttons: {
						integrityCheck: 'Integrity check',
						cleanStorage: 'Clean storage',
						listSpace: 'List space usage',
						breakBinaries: 'Break binaries',
						refreshCustomGraphs: 'Refresh custom graphs',
						refreshModulesCache: 'Refresh modules cache',
						analyzeAlertData: 'Analyze alert data',
						sendWarningEmail: 'Send warning email',
					},
					toasts: {
						integrityCheckSuccess: 'Integrity check completed successfully.',
						binariesBroken: 'Binaries broken successfully.',
						commappZipCreated: 'CommApp zip created successfully.',
						customGraphsRefreshed: 'Custom graphs refreshed successfully.',
						modulesCacheRefreshed: 'Module cache refreshed successfully.',
						storageCleaned: 'Storage cleaned successfully.',
						spaceUsageListed: 'Space usage listed successfully.',
						alertDataAnalyzed: 'Alert data analyzed successfully.',
						warningEmailSent: 'Warning email sent successfully.',
					},
				},
				dataWindow: {
					title: 'Data window',
					badge: 'Config',
					description: 'Choose the CommApp archive slice before running creation or analysis.',
					fields: {
						pcName: 'pcName',
						year: 'Year',
						month: 'Month',
						part: 'Part',
					},
					actions: {
						createCommappZip: 'Create CommApp zip',
					},
				},
				operationLog: {
					title: 'Operation log',
					badge: 'Results',
					description: 'Recent responses from admin utilities.',
				},
				ipcalls: {
					table: {
						ip: 'IP',
						country: 'Country',
						callCount: 'Call count',
						created: 'Created',
						modified: 'Modified',
						approved: 'Approved',
					},
					actions: {
						allow: 'allow',
						block: 'block',
						confirmTitle: 'Are you sure?',
						allowText: 'Allow IP {ip}',
						blockText: 'Block IP {ip}',
					},
					toasts: {
						ipAllowed: 'IP allowed',
						ipBlocked: 'IP blocked',
						listLoaded: 'IP list loaded',
					},
				},
				yocto: {
					status: {
						online: 'online',
						offline: 'offline',
						notConnected: 'Not connected to websockets - reload page',
					},
					sections: {
						futureSettings: 'Future Settings',
						onlineSettings: 'Online Settings',
						currentSensors: 'Current Sensors',
						devices: 'Devices',
						sensors: 'Sensors (yellowPages)',
						devLogs: 'dev logs',
					},
					labels: {
						logicalName: 'Logical Name',
						luminosity: 'Luminosity',
						goToSleepAfter: 'Go To Sleep After',
						wakeUpSchedule1: 'WakeUpSchedule 1',
						wakeUpSchedule2: 'WakeUpSchedule 2',
						sendModuleToSleep: 'Send Module To Sleep',
						disconnectWebsocket: 'Disconnect Websocket',
					},
					buttons: {
						setSchedule: 'Set Schedule',
						sendFutureSettings: 'Send Future Settings',
						sendSleep: 'Send Sleep',
						disconnect: 'disconnect',
						toggleDevLogs: 'dev logs',
					},
				},
			},
		},
		de: {
			admin: {
				header: {
					title: 'Admin',
				},
				systemActions: {
					title: 'Systemaktionen',
					badge: 'Schnellwerkzeuge',
					description:
						'Wartungs- und Cache-Operationen sicher ausführen. Ergebnisse erscheinen im obigen Protokoll.',
					buttons: {
						integrityCheck: 'Integritätsprüfung',
						cleanStorage: 'Speicher bereinigen',
						listSpace: 'Speicherverbrauch anzeigen',
						breakBinaries: 'Binaries beschädigen',
						refreshCustomGraphs: 'Benutzerdefinierte Diagramme aktualisieren',
						refreshModulesCache: 'Modul-Cache aktualisieren',
						analyzeAlertData: 'Alarmdaten analysieren',
						sendWarningEmail: 'Warn-E-Mail senden',
					},
					toasts: {
						integrityCheckSuccess: 'Integritätsprüfung erfolgreich abgeschlossen.',
						binariesBroken: 'Binaries wurden erfolgreich beschädigt.',
						commappZipCreated: 'CommApp-Zip erfolgreich erstellt.',
						customGraphsRefreshed: 'Benutzerdefinierte Diagramme aktualisiert.',
						modulesCacheRefreshed: 'Modul-Cache erfolgreich aktualisiert.',
						storageCleaned: 'Speicher erfolgreich bereinigt.',
						spaceUsageListed: 'Speicherverbrauch erfolgreich ausgegeben.',
						alertDataAnalyzed: 'Alarmdaten erfolgreich analysiert.',
						warningEmailSent: 'Warn-E-Mail erfolgreich gesendet.',
					},
				},
				dataWindow: {
					title: 'Datenfenster',
					badge: 'Konfiguration',
					description:
						'CommApp-Archivausschnitt auswählen, bevor Erstellung oder Analyse ausgeführt wird.',
					fields: {
						pcName: 'PC-Name',
						year: 'Jahr',
						month: 'Monat',
						part: 'Teil',
					},
					actions: {
						createCommappZip: 'CommApp-Zip erstellen',
					},
				},
				operationLog: {
					title: 'Aktionsprotokoll',
					badge: 'Ergebnisse',
					description: 'Aktuelle Antworten der Admin-Tools.',
				},
				ipcalls: {
					table: {
						ip: 'IP',
						country: 'Land',
						callCount: 'Anzahl Aufrufe',
						created: 'Erstellt',
						modified: 'Aktualisiert',
						approved: 'Freigabe',
					},
					actions: {
						allow: 'freigeben',
						block: 'sperren',
						confirmTitle: 'Sind Sie sicher?',
						allowText: 'IP {ip} erlauben',
						blockText: 'IP {ip} sperren',
					},
					toasts: {
						ipAllowed: 'IP freigegeben',
						ipBlocked: 'IP blockiert',
						listLoaded: 'IP-Liste geladen',
					},
				},
				yocto: {
					status: {
						online: 'online',
						offline: 'offline',
						notConnected: 'Keine Websocket-Verbindung - Seite neu laden',
					},
					sections: {
						futureSettings: 'Geplante Einstellungen',
						onlineSettings: 'Live-Einstellungen',
						currentSensors: 'Aktuelle Sensoren',
						devices: 'Geräte',
						sensors: 'Sensoren (YellowPages)',
						devLogs: 'Entwickler-Logs',
					},
					labels: {
						logicalName: 'Logischer Name',
						luminosity: 'Helligkeit',
						goToSleepAfter: 'Schlafen nach',
						wakeUpSchedule1: 'Aufwachplan 1',
						wakeUpSchedule2: 'Aufwachplan 2',
						sendModuleToSleep: 'Modul in Schlafmodus versetzen',
						disconnectWebsocket: 'Websocket trennen',
					},
					buttons: {
						setSchedule: 'Zeitplan setzen',
						sendFutureSettings: 'Geplante Einstellungen senden',
						sendSleep: 'Schlafbefehl senden',
						disconnect: 'trennen',
						toggleDevLogs: 'Debug-Logs',
					},
				},
			},
		},
	},
}
